import React from 'react';
import { Section, Eyebrow, Heading } from '../Section';
import { CTAButton } from '../CTAButton';
import { CountdownTimer } from '../CountdownTimer';
import { ScarcityBar } from '../ScarcityBar';
import { valueStack } from '../../data/bonuses';
export function Offer() {
  const coreItems = valueStack.filter(item => !item.bonus);
  const bonusItems = valueStack.filter(item => item.bonus);
  return <Section id="offer" tone="darker" data-id="element-171" data-mp="3a68izq29eebo">
      <Eyebrow data-id="element-172" data-mp="3a56vun7yy1dl">💰 Everything you’re getting today</Eyebrow>
      <Heading data-id="element-173" data-mp="3f3qjcs27nl82">Technical System PRO 360™</Heading>

      <div className="mt-7 overflow-hidden rounded-2xl border border-white/10 bg-navy-900" data-id="element-174" data-mp="3f2fdmmp7g3eb">
        <div className="flex items-center justify-between gap-3 bg-navy-800 px-4 py-2.5" data-id="element-175" data-mp="3jw1rgi73udbp">
          <span className="text-[11px] font-bold uppercase tracking-[0.12em] text-white/60" data-id="element-176" data-mp="3nw27u8drkyle">
            System
          </span>
          <span className="text-[11px] font-bold uppercase tracking-[0.12em] text-white/60" data-id="element-177" data-mp="1pn5px2lgz2r">
            Value
          </span>
        </div>

        <ul data-id="element-178" data-mp="1kmjamncl26xo">
          {coreItems.map(item => <li key={item.label} className="flex items-start justify-between gap-3 border-b border-white/5 px-4 py-3" data-id="element-179" data-mp="1kj3x3oyk55yd">
              <span className="text-[14px] leading-snug text-white/85 sm:text-base" data-id="element-180" data-mp="1bll8ybpmabi9">
                {item.label}
              </span>
              <span className="shrink-0 font-display text-lg font-bold text-white sm:text-xl" data-id="element-181" data-mp="16o1tj8h6nsoq">
                {item.value}
              </span>
            </li>)}
        </ul>

        <div className="bg-gold-500 px-4 py-2.5" data-id="element-182" data-mp="1zch4njx71qus">
          <span className="font-display text-[13px] font-bold uppercase tracking-[0.12em] text-navy-950 sm:text-sm" data-id="element-183" data-mp="1uiuohhrtn4u8">
            Plus 5 premium systems — free
          </span>
        </div>

        <ul data-id="element-184" data-mp="2n0gvskyf3j9w">
          {bonusItems.map(item => <li key={item.label} className="flex items-start justify-between gap-3 border-b border-white/5 px-4 py-3" data-id="element-185" data-mp="2n21pk8cwqy6p">
              <span className="text-[14px] leading-snug text-white/85 sm:text-base" data-id="element-186" data-mp="316igqdi6wadc">
                {item.label}
              </span>
              <span className="shrink-0 font-display text-lg font-bold text-white/60 line-through sm:text-xl" data-id="element-187" data-mp="363simsmrmei2">
                {item.value}
              </span>
            </li>)}
        </ul>

        <div className="flex items-center justify-between gap-3 bg-navy-950 px-4 py-4" data-id="element-188" data-mp="2wco0jk1smdj0">
          <span className="font-display text-[17px] font-bold uppercase tracking-wide text-white sm:text-2xl" data-id="element-189" data-mp="2idobwcea5ymu">
            Total value
          </span>
          <span className="font-display text-[26px] font-extrabold text-white/70 line-through sm:text-3xl" data-id="element-190" data-mp="29et4iwzi2ihy">
            $677 USD
          </span>
        </div>
      </div>

      <div className="mt-8 rounded-2xl border-2 border-gold-500 bg-navy-900 p-5 text-center sm:p-7" data-id="element-191" data-mp="2dhprt0zzj2s8">
        <p className="text-[15px] font-semibold text-white/80 sm:text-lg" data-id="element-192" data-mp="7l3k01f8ycc0">
          But today you won’t pay $677. You won’t even pay half.
        </p>
        <p className="mt-4 font-display text-[15px] font-bold uppercase tracking-[0.14em] text-red-400 sm:text-lg" data-id="element-193" data-mp="1w7diwae76x60">
          🔥 Today you can get everything for just
        </p>
        <p className="mt-1 font-display text-[72px] font-extrabold leading-none text-gold-500 sm:text-[110px]" data-id="element-194" data-mp="25wnazq91kfu4">
          $27
        </p>
        <p className="font-display text-lg font-bold uppercase tracking-[0.2em] text-white sm:text-2xl" data-id="element-195" data-mp="214cbupm4ky2m">
          USD
        </p>
        <p className="mt-3 text-[13px] font-semibold text-white/70 sm:text-base" data-id="element-196" data-mp="2avgrzsnjeoz1">
          One-time payment · No monthly fees · Lifetime access
        </p>
        <p className="mt-2 text-[12px] font-medium text-white/60 sm:text-sm" data-id="element-197" data-mp="2oupu5oewrik0">
          💱 Your currency is converted automatically based on your location.
        </p>

        <div className="mt-6" data-id="element-198" data-mp="ugf5ph286qer">
          <CTAButton label="Yes — I want immediate access for $27" data-id="element-199" data-mp="uhqjm9pdxejl" />
        </div>
      </div>

      <div className="mt-6" data-id="element-200" data-mp="pjf7ttfj4tyq">
        <CountdownTimer label="The promotional offer ends in" note="Don’t wait until you’ve spent another year building your business with scattered notes, random forms and improvised processes." data-id="element-201" data-mp="pki1280br8ht" />
      </div>

      <div className="mt-4" data-id="element-202" data-mp="10wys3xk3ry4j">
        <ScarcityBar data-id="element-203" data-mp="10y06oc0bv2r0" />
      </div>
    </Section>;
}